<div class="flex flex-row">
    <ul class="breadcrumbs flex flex-row items-center gap-x-2">
        <li>
            <a
                routerLink="/"
                [fuiTooltip]="appService.language_dictionary.main_home_page"
                class="breadcrumbs-link-home"
            >
                <mat-icon class="breadcrumbs-icon-home" fontSet="mdi" fontIcon="mdi-home"></mat-icon>
            </a>
        </li>
        <ng-container *ngIf="breadcrumbs$ | async as breadcrumbs">
            <li
                *ngFor="let breadcrumb of breadcrumbs; let last = last; trackBy: trackByLink"
                [class.dynamic]="breadcrumb.isDynamic"
            >
                <ng-container *ngIf="!last && breadcrumb.link; else emptyLink">
                    <a
                        [routerLink]="breadcrumb.link"
                        [class.truncate]="breadcrumb.isDynamic"
                        [fuiTooltip]="breadcrumb.isDynamic ? breadcrumb.name : null"
                        >{{ breadcrumb.name }}</a
                    >
                </ng-container>
                <ng-template #emptyLink>
                    <span
                        class="cursor-default"
                        [class.truncate]="breadcrumb.isDynamic"
                        [fuiTooltip]="breadcrumb.isDynamic ? breadcrumb.name : null"
                    >
                        {{ breadcrumb.name }}
                    </span>
                </ng-template>
            </li>
        </ng-container>
    </ul>
</div>
